// File: /src/services/dashboardService.js
import axios from "axios";
import { Base_URL } from "../url";
import { Base_URL2 } from "../url";

// Fetch company codes for an organization
export const fetchCompanyCodes = async (organisationId, token) => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectViewDashboard/company-codes`,
      {
        params: {
          OrganisationID: organisationId,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching company codes:", error);
    throw error;
  }
};

export const fetchPDashboardData = async (filters, user, token) => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectViewDashboard/projects`,
      {
        params: {
          OrganisationID: user?.organisation_id || filters.OrganisationID,
          CompanyCode: filters.companyCode || null,
          FiscalYear: filters.fiscalYear || null,
          FiscalMonth: filters.fiscalMonth || null,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching dashboard data:", error);
    throw error;
  }
};

// Fetch Project Hours View data
export const fetchProjectHours = async (organisationId, token) => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectHoursView/GetProjectHours/${organisationId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching project hours:", error);
    throw error;
  }
};
